import { isYesterday } from "date-fns";
import dayjs from "dayjs";
import { capitalize } from "lodash-es";

export function timeAgo(timestamp: number, verbose = true): string {
  if (!verbose) return dayjs(timestamp).fromNow();

  const now = new Date();
  const date = new Date(timestamp);
  const diff = now.getTime() - date.getTime();

  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);

  // Under a minute
  if (seconds < 60) {
    return "Just now";
  }
  // Between a minute and one hour
  if (minutes < 60) {
    return `${minutes}m ago`;
  }
  // Over an hour but same day
  if (hours < 24 && now.getDate() === date.getDate()) {
    return `${hours}h ago`;
  }
  // 11:59 pm or before the previous day
  if (isYesterday(date)) {
    return `Yesterday · ${formatTime(date)}`;
  }
  // Before yesterday
  return `${formatDate(date)} · ${formatTime(date)}`;
}

export function formatTime(date: Date): string {
  return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
}

export function formatDate(date: Date): string {
  return date.toLocaleDateString([], { month: "short", day: "numeric" });
}

export function formatDateWithYear(date: Date): string {
  return date.toLocaleDateString([], { month: "short", day: "numeric", year: "numeric" });
}

export function formatName(first?: string | null, last?: string | null): string {
  return `${capitalize(first || "")} ${capitalize(last || "")}`;
}

export function formatTag(tag: string): string {
  return tag.replace(/_/g, " ").split(" ").map(capitalize).join(" ");
}